import { gql } from '@/shared/graphql/generated/lp';

gql(/* GraphQL */ `
  fragment LimitOrderFill on LimitOrderFill {
    id
    tick
    type
    orderId
    baseAsset
    sellAmount
    filledAmount
    blockTimestamp
    sellAmountValueUsd
    filledAmountValueUsd
    originalSellAmount
    originalSellAmountValueUsd
    lp: accountByLiquidityProviderId {
      idSs58
    }
  }

  fragment RangeOrderFill on RangeOrderFill {
    id
    orderId
    liquidity
    baseAsset
    blockTimestamp
    rangeEndTick
    rangeStartTick
    baseFilledAmount
    quoteFilledAmount
    baseFilledAmountValueUsd
    quoteFilledAmountValueUsd
    baseReceivedAmount
    quoteReceivedAmount
    baseFeesEarned
    quoteFeesEarned
    lp: accountByLiquidityProviderId {
      idSs58
    }
  }
`);

export const GetLpEarnedFeeAggregates = gql(/* GraphQL */ `
  query getLpEarnedFeeAggregates(
    $idSs58: String!
    $minTimestamp: Datetime!
    $maxTimestamp: Datetime!
    $limitOrderGroupBy: [LimitOrderFillGroupBy!]!
    $rangeOrderGroupBy: [RangeOrderFillGroupBy!]!
    $boostShareGroupBy: [BoostShareGroupBy!]!
  ) {
    account: accountByIdSs58(idSs58: $idSs58) {
      limitOrderFees: limitOrderFillsByLiquidityProviderId(
        filter: {
          and: [
            { blockTimestamp: { greaterThanOrEqualTo: $minTimestamp } }
            { blockTimestamp: { lessThanOrEqualTo: $maxTimestamp } }
          ]
        }
        orderBy: BLOCK_TIMESTAMP_DESC
      ) {
        groupedAggregates(groupBy: $limitOrderGroupBy) {
          keys
          sum {
            feeUsd: feesEarnedValueUsd
          }
        }
      }
      rangeOrderFees: rangeOrderFillsByLiquidityProviderId(
        filter: {
          and: [
            { blockTimestamp: { greaterThanOrEqualTo: $minTimestamp } }
            { blockTimestamp: { lessThanOrEqualTo: $maxTimestamp } }
          ]
        }
        orderBy: BLOCK_TIMESTAMP_DESC
      ) {
        groupedAggregates(groupBy: $rangeOrderGroupBy) {
          keys
          sum {
            baseFeeUsd: baseFeesEarnedValueUsd
            quoteFeeUsd: quoteFeesEarnedValueUsd
          }
        }
      }
      boostFees: boostSharesByLiquidityProviderId(
        filter: {
          and: [
            { executedAtTimestamp: { greaterThanOrEqualTo: $minTimestamp } }
            { executedAtTimestamp: { lessThanOrEqualTo: $maxTimestamp } }
          ]
        }
        orderBy: EXECUTED_AT_TIMESTAMP_DESC
      ) {
        groupedAggregates(groupBy: $boostShareGroupBy) {
          keys
          sum {
            feeUsd
          }
        }
      }
    }
  }
`);

export const getAllLpsTotalVolumeQuery = gql(/* GraphQL */ `
  query getAllLpsTotalVolumeQuery {
    limitOrders: allLimitOrderFills {
      aggregates {
        sum {
          filledAmountValueUsd
        }
      }
    }
    rangeOrders: allRangeOrderFills {
      aggregates {
        sum {
          baseFilledAmountValueUsd
          quoteFilledAmountValueUsd
        }
      }
    }
  }
`);

export const getLpsVolumeQuery = gql(/* GraphQL */ `
  query getLpsVolumeQuery($idSs58: String!, $startDate: Datetime, $endDate: Datetime) {
    accounts: allAccounts(condition: { idSs58: $idSs58 }) {
      nodes {
        idSs58
        strategies: tradingStrategiesByOwnerAccountId {
          nodes {
            strategy: accountByStrategyAccountId {
              limitOrders: limitOrderFillsByLiquidityProviderId(
                filter: {
                  blockTimestamp: { greaterThanOrEqualTo: $startDate, lessThanOrEqualTo: $endDate }
                }
              ) {
                aggregates {
                  sum {
                    filledAmountValueUsd
                  }
                }
              }
            }
          }
        }
        limitOrders: limitOrderFillsByLiquidityProviderId(
          filter: {
            blockTimestamp: { greaterThanOrEqualTo: $startDate, lessThanOrEqualTo: $endDate }
          }
        ) {
          aggregates {
            sum {
              filledAmountValueUsd
            }
          }
        }
        rangeOrders: rangeOrderFillsByLiquidityProviderId(
          filter: {
            blockTimestamp: { greaterThanOrEqualTo: $startDate, lessThanOrEqualTo: $endDate }
          }
        ) {
          aggregates {
            sum {
              quoteFilledAmountValueUsd
              baseFilledAmountValueUsd
            }
          }
        }
      }
    }
  }
`);

export const getLpProcessorLpIdQuery = gql(/* GraphQL */ `
  query GetLpId($idSs58: String!) {
    account: accountByIdSs58(idSs58: $idSs58) {
      id
    }
  }
`);

export const getOrderFillsQuery = gql(/* GraphQL */ `
  query GetOrderFills(
    $id: Int
    $asset: ChainflipAsset
    $startDate: Datetime
    $endDate: Datetime
    $minFilledValueUsd: BigFloat
    $first: Int
  ) {
    limitOrderFills: allLimitOrderFills(
      filter: {
        liquidityProviderId: { equalTo: $id }
        baseAsset: { equalTo: $asset }
        blockTimestamp: { greaterThanOrEqualTo: $startDate, lessThanOrEqualTo: $endDate }
        filledAmountValueUsd: { greaterThanOrEqualTo: $minFilledValueUsd }
      }
      first: $first
      orderBy: ID_DESC
    ) {
      nodes {
        ...LimitOrderFill
      }
    }
    rangeOrderFills: allRangeOrderFills(
      filter: {
        liquidityProviderId: { equalTo: $id }
        baseAsset: { equalTo: $asset }
        blockTimestamp: { greaterThanOrEqualTo: $startDate, lessThanOrEqualTo: $endDate }
        or: [
          { quoteFilledAmountValueUsd: { greaterThanOrEqualTo: $minFilledValueUsd } }
          { baseFilledAmountValueUsd: { greaterThanOrEqualTo: $minFilledValueUsd } }
        ]
      }
      first: $first
      orderBy: ID_DESC
    ) {
      nodes {
        ...RangeOrderFill
      }
    }
  }
`);
